/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DlNodeVolgerDirective} from '../../../../../directives/dl-node-volger/dl-node-volger.directive';
import {BaseNodeMenuComponent} from '../../../base-node-menu.component';

@Component({
    selector: 'nodemenu-q-exo',
    standalone: true,
    imports: [DlNodeVolgerDirective, TranslateModule],
    templateUrl: './nodemenu-q-exo.component.html',
    styleUrls: ['./nodemenu-q-exo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodemenuQExoComponent extends BaseNodeMenuComponent {
    constructor() {
        super();
    }
}
